import { useI18NextContext } from '@components/hooks';
import styled from '@emotion/styled';
import { Place } from '@model/iceberg/geography';
import React from 'react';
import { getTranslatedHTML } from '@util/common';
import { ThemeProps } from '@theme/base';

export interface ReasonProps {
  place: Place;
  name: string;
  isDestination: boolean;
}

const Paragraph = styled.div(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  color: theme.custom.colors.group4.base
}));

export const Reason = ({ name, place, isDestination }: ReasonProps) => {
  const t: any = useI18NextContext();

  if (isDestination) {
    return (
      <Paragraph
        dangerouslySetInnerHTML={getTranslatedHTML(t, 'no-results__search--destination', {
          destination: `<b>${name}</b>`
        })}
      />
    );
  }
  if (place.hotel && place.hotel.path) {
    return (
      <Paragraph
        dangerouslySetInnerHTML={getTranslatedHTML(t, 'no-results__search--hotel', {
          hotel: `<b>${place.hotel.display}</b>`,
          search: `<b>${place.resort.display}, ${place.region.display}</b>`
        })}
      />
    );
  }
  if (place.resort && place.resort.path) {
    return (
      <Paragraph
        dangerouslySetInnerHTML={getTranslatedHTML(t, 'no-results__search--resort', {
          resort: `<b>${place.resort.display}</b>`,
          search: `<b>${place.region.display}, ${place.country.name.display}</b>`
        })}
      />
    );
  }
  return (
    <Paragraph
      dangerouslySetInnerHTML={getTranslatedHTML(t, 'no-results__search--generic', { destination: `<b>${name}</b>` })}
    />
  );
};
